/**
 * 菜单管理服务
 */

import { httpClient } from './httpClient';
import { API_ENDPOINTS } from './api/config';

export const menuService = {
  async getList(params: any) {
    return httpClient.get(API_ENDPOINTS.MENU.LIST, { params });
  },
  
  async getById(id: number) {
    return httpClient.get(`${API_ENDPOINTS.MENU.DETAIL}/${id}`);
  },
  
  async create(data: any) {
    return httpClient.post(API_ENDPOINTS.MENU.CREATE, data);
  },
  
  async update(data: any) {
    return httpClient.put(API_ENDPOINTS.MENU.UPDATE, data);
  },
  
  async delete(id: number) {
    return httpClient.delete(`${API_ENDPOINTS.MENU.DELETE}/${id}`);
  },
  
  async batchDelete(ids: number[]) {
    return httpClient.delete(`${API_ENDPOINTS.MENU.DELETE}/batch`, { data: ids });
  }
};

export default menuService;